import { ModulesEnum, ModulesGroupingEnum } from "./modules";

export interface UserAuthData {
  CustomToken: string;
  AccessToken: string;
  AuthToken: string;
  RefreshToken: string;
  Businesses: Business[];
  DefaultBusiness: Business;
  Vendors: Vendor[];
  Driver: any;
  User: User;
}
export interface User {
  Uid: string;
  FullName: string;
  Phone: string;
  WhatsAppNumber: string | null;
  Email: string;
  IsSuperUser: boolean;
  SuperUserAccessLevelId: any;
  SuperUserAccessLevelName: string;
  IsSystemAdministrator: boolean;
}

export interface Business {
  Modules: Module[];
  Name: string;
  Uid: string;
}

export interface Vendor {
  Name: string;
  Uid: string;
}


export interface Module {
  Module: ModulesEnum;
  ModuleNiceName: string;
  RouterLink: string;
  AccessLevel: string;
  ModuleIcon: string;
  ChildRoutes?: ModuleChildRoute[];
  DisplayName: string;
  isActive?: boolean;
}

export interface GroupedModules {
  GroupingName: ModulesGroupingEnum;
  Modules: Module[];
  Expanded?: boolean;
}

export interface ModuleChildRoute {
  RouterLink: string;
  LinkNiceName: string;
  LinkIcon: string;
}

export interface BusinessChangeEvent {
  label: string;
  id: string;
}

export enum StorageKeyEnum {
  UserData = 'UserData',
  AuthToken = 'AuthToken',
}
